import React, { useState } from "react";
import heroImage2 from "../Assests/hero result 1.jpeg";
import heroImage3 from "../Assests/test.jpg";  
import heroImage4 from "../Assests/hero result 2.jpeg"; 


const Hero = () => {
  const images = [heroImage2, heroImage3,heroImage4];
  const [index, setIndex] = useState(0);

  const next = () => setIndex((prev) => (prev + 1) % images.length);
  const prev = () =>
    setIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div className="w-full py-2">

      {/* ⭐ TOP MARQUEE BAR ⭐ */}
      <div className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-2 overflow-hidden">
        <marquee behavior="scroll" direction="left" scrollamount="6" className="text-lg font-semibold">
           📢 Admissions Open 2026 | Best Coaching Classes in Maharashtra | Limited Seats! Enroll Now 🚀
        </marquee>
      </div>

      {/* ⭐ HERO SLIDER ⭐ */}
<div class="relative w-full max-w-[98%] ml-2 mr-2 max-h-[400px] h-[400px] mt-2 rounded-xl overflow-hidden shadow-xl">


        {/* SLIDE WRAPPER */}
        <div
          className="flex transition-transform duration-700 ease-out h-full"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {images.map((src, i) => (
            <div
              key={i}
              className="min-w-full h-full flex-shrink-0 flex items-center justify-center bg-white"
            >
              <img
                src={src}
                alt={`Slide ${i}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

        {/* LEFT ARROW */}
        <button
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-lg backdrop-blur"
        >
          <svg className="w-5 h-5" fill="none" stroke="black" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        {/* RIGHT ARROW */}
        <button
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-lg backdrop-blur"
        >
          <svg className="w-5 h-5" fill="none" stroke="black" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* DOTS */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-3">
          {images.map((_, i) => (
            <div
              key={i}
              onClick={() => setIndex(i)}
              className={`w-3 h-3 rounded-full cursor-pointer transition-all ${
                i === index ? "bg-white scale-125 shadow-lg" : "bg-white/40"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
